/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { BrandColors, MaterialIcon } from '@blend/enterprise-components';
import styled from 'styled-components';
import { Box, Text } from 'grommet';
import { useThemeColor as c } from '@blend/alchemy';

export namespace NavLinkButton {
  export interface Props {
    id?: string;
    iconType: any;
    isActive: boolean;
    label: string;
    onClick?: () => void;
  }
}

const ButtonWrapper = styled(Box)`
  cursor: pointer;
  outline: none;

  &.active {
    background-color: ${c('night60')};
  }
`;

export const NavLinkButton: React.FC<NavLinkButton.Props> = ({ id, iconType, label, onClick, isActive }) => {
  return (
    <ButtonWrapper
      align="center"
      border={{ size: 'none' }}
      className={isActive ? 'active' : ''}
      data-it={`NavLinkButton-${label.toLowerCase()}`}
      direction="row"
      id={id}
      onClick={onClick}
      pad={{ horizontal: 'small', vertical: 'xsmall' }}
      round="20px"
      width="228px"
    >
      {iconType && <MaterialIcon color={BrandColors.WHITE} size={22} type={iconType} />}
      <Text color="white" margin={{ left: 'medium' }} size="medium" weight="normal">
        {label}
      </Text>
    </ButtonWrapper>
  );
};
